<template lang="pug">
  .page
    slot(v-if="loaded")
    .error(v-if="failed")
      page-load-error(v-on:reload="onReload")
</template>

<script>
import PageLoadError from '@/components/ui/errors/PageLoadError/PageLoadError';

export default {
  data() {
    return {
      loaded: false,
      failed: false
    };
  },

  props: {
    payload: {
      required: true,
      type: Function
    }
  },

  methods: {
    onReload() {
      this.load();
    },

    load() {
      this.$store.commit('startLoad');
      this.payload()
        .then(() => {
          this.$store.commit('endLoad');
          this.$emit('loaded');
          this.failed = false;
          this.loaded = true;
        })
        .catch(() => {
          this.$store.commit('endLoad');
          this.loaded = false;
          this.failed = true;
        });
    }
  },

  mounted() {
    this.load();
  },

  components: {
    PageLoadError
  }
};
</script>
